import React from 'react';
import Select from 'react-select';

const Branches = (props) => {
    
    const branches = props.availableBranches;

    const handleChange = (e) => {
        e = e.map(branch => branch.value);
        props.updateBranches(e);
    };

    return (
        <div>
            <div>
                <Select
                    isMulti
                    options={branches.map(branch => ({
                        value: branch.number,
                        label: branch.description,
                        isDisabled: branch.isDefault
                    }))}
                    value={props.modalBranches.map(branch => {
                        return {
                            value: branch, label: branches.find(b => b.number === branch).description ?? branch
                        }
                    })}                    
                    onChange={handleChange}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                />
                
            </div>
        </div>
    );
};

export default Branches;